import React, { Fragment } from 'react'
import Header from './Header';
import Footer from './Footer';
import BannerSlider from './BannerSlider';
// import ServicesSlider from './ServicesSlider';
import Accordion from './Accordion.jsx';
import { Link } from 'react-router-dom';
import Testimonial from './Testimonial.jsx'
import Count from './Count.jsx';
// import WebSlider from './WebSlider';
import ClientSlider from './ClientSlider.jsx';


const Home = () => {

  return (
    <Fragment>

      <Header />
      <BannerSlider />

      <section class="home-about-section section-1">

        <div class="position-relative">


          <div class="animation-home-about animation-round-bg top-right"></div>
          <div class="animation-home-about animation-round-bg bottom-left"></div>
        </div>
        <div class="container">
          <div class="row home-about-container">


            <div class="col-lg-5 col-md-9  home-about-container-logo">
              <div class="image-wrapper">
                <img class="main-image" src="assets/home-1.webp" alt="Web Development Service" loading="lazy" />
                <img class="glass-frame" src="assets/banners/about-bg.png" alt="Glass Frame Overlay" loading="lazy" />
              </div>
            </div>


            <div class="col-lg-7 col-md-10 home-about-container-inside">
              <span class="p_t">Partner</span>
              <h2 class="">
                <span class="gradient-text">Kumbhatech Solutions</span> Your Partner in Affordable Web Development
              </h2>
              <p>
                At KumbhaaTech Solutions, exceptional web design and development are within everyone's reach. As a leading software company, we specialize in crafting beautiful, functional websites tailored to your unique needs without breaking the bank. We believe that exceptional web design shouldn’t come with a hefty price tag.
              </p>
              <br />
              <p>
                Whether you’re a small business, a startup, or an individual looking to establish an online presence, our team is here to bring your vision to life with innovative design and cutting-edge technology. Our commitment to quality and customer satisfaction sets us apart in the industry.
              </p>

              <a href="https://calendly.com/kumbhaatech/15min" target="_blank" className="patnr-btn" rel="noopener noreferrer">
                Book a Meeting
              </a>
            </div>

          </div>
        </div>

        <Count />
      </section>

      {/*   <section className='abt-count-section' id='number'>
       
      </section>
 */}



      <section className="platform ">
        <div class="position-relative">
          {/* <div class="animation-home-about animation-round-bg top-right"></div> */}
          <div class="animation-home-about animation-round-bg bottom-left-2"></div>
        </div>
        <div className="container">
          <div className="row  justify-content-between">
            <div className="platform-affordable-design col-lg-3">
              <h2 className=''>
                Our <span className="gradient-text">Affordable</span> <span className="gradient-text">Website</span> Design Services
              </h2>
              <br />
              <p style={{ color: '#000' }}>
                "Discover our affordable website design services at Kumbhatech Solutions. We specialize in creating sleek,
                user-friendly websites that enhance your online presence. Whether you're a startup or an established business,
                our expert team delivers tailored solutions to meet your needs. "
              </p>
            </div>
            <div className="col-lg-8">
              <div className="platforms-solutions">


                <div className="platforms-solutions-card-wrapper m-r-f">

                  <div className="platforms-solutions-card-1 bg-hover-g-1">
                    <img src="assets/images/icons/online.png" loading="lazy" alt='Launch Your Online Presence' />
                    <div className="platforms-solutions-card-1-child">
                      <h3>Launch Your Online Presence</h3>
                      <p>Perfect for small businesses and startups, offering essential features like contact info, about us, and services.</p>
                    </div>
                  </div>
                  <span className='plat-box-1'></span>
                </div>

                <div className="platforms-solutions-card-wrapper">
                  <div className="platforms-solutions-card-2 bg-hover-g-2 m-f" >
                    <img src="assets/images/icons/grow.png" loading="lazy" alt='Grow Your Business Online' />
                    <div className="platforms-solutions-card-2-child">
                      <h3>Grow Your Business Online</h3>
                      <p>Showcase your products and services to attract customers and boost sales.</p>
                    </div>
                  </div>
                  <div className="platforms-solutions-card-2 bg-hover-g-3">
                    <img src="assets/images/icons/selling.png" loading="lazy" alt='Start Selling Online' />
                    <div className="platforms-solutions-card-2-child">
                      <h3>Start Selling Online</h3>
                      <p>Sell your products with secure payments and easy product management.</p>
                    </div>
                  </div>
                </div>


                <div className="platforms-solutions-card-wrapper m-w-r-1">
                  <span className='plat-box-2'></span>
                  <div className="platforms-solutions-card-1 bg-hover-g-4 or-2">
                    <img src="assets/images/icons/unique.png" loading="lazy" alt='Custom Websites for Unique Needs' />
                    <div className="platforms-solutions-card-1-child">
                      <h3>Custom Websites for Unique Needs</h3>
                      <p>Tailored solutions to meet your business's specific requirements and functionality.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='kt-acc-section '>
        <div class="position-relative">

          <div class="animation-home-about animation-round-bg top-center"></div>

        </div>
        <div className="container">
          <div className="row kt-acc-container">
            <div className='col-lg-6 kt-acc-con col-md-10'>
              <h2 className=''>Why Choose <span className="gradient-text">Kumbhatech</span> Solutions for <span className="gradient-text">Your</span> Website Needs?</h2>
              <Accordion />
            </div>

            <div className="col-lg-6 ">
              <div className='acc-image-container'>
                <img loading='lazy' decoding='async' src="assets/banners/ac_imge.webp" alt="Kumbhatech Highlights" className="img-fluid custom-clip" />
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* <section className='key-module-bg '>
        <div class="container">
          <div className='features-courseProject'>
            <div class="row">
              <div class=" webSlider-heading col-lg-7">
                <h2> Benefits of Choosing <span className="gradient-text1">Kumbhatech </span></h2>
                <p style={{ color: 'white' }}>Choosing Kumbhatech Solutions ensures tailored, industry-specific expertise, reliable quality, and agile solutions, empowering businesses to excel in a digitally transformed landscape with innovation and trust.</p>
              </div>
              <div class="key-modules-container">
                <div class="key-module">
                  <div class="key-image-container">
                    <img src="assets/images/Cost -effectly-red.png" alt="Static" class="static-image" loading='lazy' decoding='async' />
                    <img src="assets/images/Cost -effectly.gif" alt="Animated" class="animated-image" loading='lazy' decoding='async' />
                 
                  </div>
                  <h5>Cost-Effective</h5>
                  <div class="module-content">
                    <p>We offer cheap web design services that are significantly lower than traditional web design agencies, yet deliver exceptional quality and results.</p>
                    <Link to='/kumbhatech-affordable-website-design-chennai' className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                    </Link>
                  </div>
                </div>
                <div class="key-module">
                  <div class="key-image-container">
                    <img src="assets/images/quality-red.png" alt="Static" class="static-image" loading='lazy' decoding='async' />
                    <img src="assets/images/quality.gif" alt="Animated" class="animated-image" loading='lazy' decoding='async' />
                 
                  </div>
                  <h5>Quality & Efficiency</h5>
                  <div class="module-content">
                    <p>We leverage efficient processes and the latest technologies to deliver high-quality websites within your budget and timeframe.</p>
                    <Link to='/kumbhatech-affordable-website-design-chennai' className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                    </Link>
                  </div>
                </div>
                <div class="key-module">
                  <div class="key-image-container">
                    <img src="assets/images/Team-red.png" alt="Static" class="static-image" loading='lazy' decoding='async' />
                    <img src="assets/images/team.gif" alt="Animated" class="animated-image" loading='lazy' decoding='async' />
                  
                  </div>
                  <h5>Experienced Team</h5>
                  <div class="module-content">
                    <p>Our team of skilled designers and developers possesses extensive experience in creating websites that are not only visually appealing but also strategically designed to achieve your business goals.</p>
                    <Link to='/kumbhatech-affordable-website-design-chennai' className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                    </Link>
                  </div>
                </div>
                <div class="key-module">
                  <div class="key-image-container">
                    <img src="assets/images/Scalability-red.png" alt="Static" class="static-image" loading='lazy' decoding='async' />
                    <img src="assets/images/Scalability.gif" alt="Animated" class="animated-image" loading='lazy' decoding='async' />
                  
                  </div>
                  <h5>Scalability</h5>
                  <div class="module-content">
                    <p>We design your website with scalability in mind, allowing you to easily add new features and functionalities as your business grows.</p>
                    <Link to='/kumbhatech-affordable-website-design-chennai' className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                    </Link>
                  </div>
                </div>
                <div class="key-module">
                  <div class="key-image-container">
                    <img src="assets/images/peace-red.png" alt="Static" class="static-image" loading='lazy' decoding='async' />
                    <img src="assets/images/space.gif" alt="Animated" class="animated-image" loading='lazy' decoding='async' />
                
                  <h5>Peace of Mind</h5>
                  <div class="module-content">
                    <p>We handle all the technical aspects of website design and development, allowing you to focus on running your business.</p>
                    <Link to='/kumbhatech-affordable-website-design-chennai' className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                    </Link>
                  </div>
                </div>
                <div class="key-module">
                  <div class="key-image-container">
                    <img src="assets/images/support-red.png" alt="Static" class="static-image" loading='lazy' decoding='async' />
                    <img src="assets/images/support.gif" alt="Animated" class="animated-image" loading='lazy' decoding='async' />
                   
                  </div>
                  <h5>Support</h5>
                  <div class="module-content">
                    <p>Don't let the low cost web design fool you. Our team of experienced designers creates visually appealing and user-friendly websites that effectively represent your brand and resonate with your target audience.</p>
                    <Link to='/kumbhatech-affordable-website-design-chennai' className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section class="chsing-section section-1">
        <div class="position-relative">

          <div class="animation-home-about animation-round-bg top-center "></div>

        </div>
        <div class="container">
          <div className='row chsing-section-heading' style={{ alignItems: 'center' }}>
            <div class=" col-lg-7 col-md-10">
              <h2 style={{ color: 'white' }}> Benefits of Choosing <span className="gradient-text1">Kumbhatech </span></h2>
              <br />
              <p style={{ color: 'white' }}>Choosing Kumbhatech Solutions ensures tailored, industry-specific expertise, reliable quality, and agile solutions, empowering businesses to excel in a digitally transformed landscape with innovation and trust.</p>
            </div>
            <div className='col-lg-5' >
              <div className='b_know_btn'>
                <Link to='/kumbhatech-affordable-website-design-chennai' >Know More<i class="fa fa-arrow-right"></i></Link> </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-7" >
              <div class="update-ching-card " >
                <figure class="update-ching-figure-wrap">
                  <img
                    src="/assets/cost-home.webp"
                    alt="cost effective"
                  />
                </figure>
                <div class="update-ching-content">
                  <h3>Cost Effective</h3>
                  <p>Affordable web design with great quality, much cheaper than traditional agencies.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="Home_Card_right">
                <div class="Home_Card_right_image">
                  <img src="assets/images/New folder/quality.webp" alt="Quality web design" />
                </div>
                <div class="Home_Card_right_content">
                  <h4>Quality & Efficiency</h4>
                  <p>Fast, high-quality websites that fit your budget and timeline.</p>
                </div>
              </div>
              <div class="Home_Card_right">
                <div class="Home_Card_right_image">
                  <img src="assets/banners/ei-1.webp" alt="Experienced team" />
                </div>
                <div class="Home_Card_right_content">
                  <h4>Experienced Team</h4>
                  <p>Skilled designers and developers focused on your business goals.</p>
                </div>
              </div>
              <div class="Home_Card_right">
                <div class="Home_Card_right_image">
                  <img src="assets/images/New folder/scaliblity.webp" alt="Scalable solutions" />
                </div>
                <div class="Home_Card_right_content">
                  <h4>Scalability</h4>
                  <p>Websites designed to grow as your business expands.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* 
       <section className="careers-section">
        <div className="container">
          <div className="careers-container">
            <div className="careers-content">
              <h1>Careers at KumbhaTech</h1>
              <p>Don't let budget constraints limit your online potential. Contact Kumbhatech Solutions today for a free consultation and quote. We'll discuss your needs, answer your questions, and help you craft a website that effectively represents your brand and drives business growth. Let us show you how affordable website design can be powerful and impactful!.</p>
              <div className='service-links' >
                <Link to='/all-services'>View Carrer Page</Link>
              </div>
            </div>
          </div>
        </div>
      </section>  */}
      <section className="upcoming-meeting-client section-1" id="meetings">
        <div class="position-relative">

          <div class="animation-home-about animation-round-bg top-right"></div>
          {/* <div class="animation-home-about animation-round-bg bottom-left-2"></div> */}
        </div>
        <div className="container">

          <div className='client-heading col-lg-8 col-md-10'>
            <h2 ><span className='gradient-text '>Meet</span> Our Clients</h2>
            <p>"Unlock the potential of your online presence with affordable website design services at Kumbhatech Solutions. We specialize in crafting sleek, user-friendly websites that help boost your digital visibility. Whether you're a startup or an established business, our expert team is committed to delivering personalized solutions tailored to your specific needs. Reach out to us today and take your digital footprint to the next level!"</p>
          </div>

          <br />
          <ClientSlider />
        </div>
      </section>

      <section className="testimonial-section ">
        <div class="position-relative">

          {/* 
          <div class="animation-home-about animation-round-bg top-center "></div> */}
        </div>
        <div className='container'>


          <div className=' col-lg-7 test-heading col-md-10'>

            <h2>What's Our <span className='gradient-text '>Client</span> Says</h2>
            <p> Hear directly from our valued clients about their experiences working with us. We take pride in
              delivering exceptional results, and their words reflect our commitment to excellence.</p>
          </div>
          <Testimonial />
        </div>
      </section>



      {/* <section className="services-over" id="meetings">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <h2 className='h2'>Featured Trends and Insights</h2>
              <br />
            </div>
          </div>
          <ServicesSlider />
        </div>


      </section> */}
      <section className="kumbha-items-section section-1">
        <div className="container">
          <div className="item-section">
            <div className="item-text">
              <h2> <span className='gradient-text'>Experience </span>Our Services YourSelf</h2>
              <p>We offer a comprehensive range of services tailored to meet the unique needs of each client. Whether you're seeking personalized solutions or full-scale support, our dedicated team is here to guide you every step of the way.</p>
            </div>

            <div className="item-button">
              <a href="https://calendly.com/kumbhaatech/15min" target="_blank" rel="noopener noreferrer">
                Talk to a Specialist
              </a>

            </div>

          </div>
        </div>
      </section>

      <Footer />

    </Fragment >
  )
}

export default Home;
/* <a href="https://www.freepik.com/free-photo/cute-woman-jumping-isolated-blue-with-copy-space_14565061.htm#fromView=image_search&page=4&position=35&uuid=e9ba25a0-40c1-448d-b853-7a673940d692">Image by freepik</a>abnner */